import FeatureApi from "../../services/api/Feature";
import { getPath, pushOrUpdate, removeCondition } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import * as Comparators from "../../constants/FeatureToggle/Comparators";
import _ from "lodash-es";

function handleError(err) {
  console.log("error in feature actions:", err);
}

const payload = {
  clientId: "1",
};

export const setFeatureList = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_LIST,
    payload,
  };
};

export const setActiveFeature = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FEATURE,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS,
    payload,
  };
};

export const setCurrentPageFeature = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_FEATURE,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_FEATURE,
    payload,
  };
};

export const setDSMEnabledFeatures = (payload) => {
  return {
    type: ActionTypes.SET_DSM_ENABLED_FEATURES,
    payload,
  };
};

export const getFeatureList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let featurePayload = {
        ...payload,
        filters: _.cloneDeep(filters),
        pageRequest: pageRequest,
      };
      _.unset(featurePayload, ["filters", "serviceId"]);
      dispatch(setLoader(true));
      let response = await FeatureApi.getFeatureList(featurePayload);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setFeatureList(response));
        dispatch(setDSMEnabledFeatures(response?.deliveryServiceFeatures));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageFeature(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getFeature = (id) => async (dispatch) => {
  try {
    let featurePayload = {
      id: id,
      ...payload,
    };
    dispatch(setLoader(true));
    const response = await FeatureApi.getFeature(featurePayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveFeature(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createFeature = (data) => async (dispatch) => {
  try {
    let featurePayload = { ...data, ...payload };
    dispatch(setLoader(true));
    let response = await FeatureApi.createFeature(featurePayload);
    dispatch(setLoader(false));
    if (response) {
      // dispatch(resetState({state : "activeFeature"}));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const deleteFeature = (data) => async (dispatch) => {
  try {
    let featurePayload = { ...data, ...payload };
    dispatch(setLoader(true));
    let response = await FeatureApi.deleteFeature(featurePayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
